import { withTheme } from '@digital-retail/falabella-ui-cross-components';
import PropTypes from 'prop-types';
import { useEffect } from 'react';
import constants from '../../../../config/constants';
import { noop } from '../../../../utils/noop';
import { getSelectedData } from '../DeliveryOptions.Helper';
import { DeliveryOptionsContentStyles } from './DeliveryOptionsContent.style';
import DeliveryOptionsList from './DeliveryOptionsList';

const DeliveryOptionsContent = ({
  type,
  data,
  setBusy,
  zoneConfig,
  setIsCambiar,
  setSelectedDeliveryOption,
  isFreeShippingApplicable,
  deviceType,
  theme,
  isDefaultComuna,
}) => {
  const themedStoresListStyles = DeliveryOptionsContentStyles(theme);

  useEffect(() => {
    setIsCambiar(false);
  }, []);

  useEffect(() => {
    if (data && data.length > 0) {
      const {
        selectedType,
        price,
        date,
        month,
        storeName,
        storeId,
        isValid,
        locationName,
        politicalId,
        isDateRange,
        parentStateName,
      } = getSelectedData(data, type, zoneConfig, isDefaultComuna);
      if (isValid) {
        setSelectedDeliveryOption({
          type: selectedType,
          price,
          date,
          month,
          locationName,
          storeName,
          storeId,
          politicalId,
          isError: false,
          isDateRange,
          isFreeShippingApplicable,
          parentStateName,
          deliveryOptionType: constants.AVAILABILITY_HOMEDELIVERY,
        });
      }
    }
  }, [data]);

  return (
    <div className="container">
      <div className="body">
        {data && data.length > 0 && (
          <DeliveryOptionsList
            data={data}
            setBusy={setBusy}
            isFreeShippingApplicable={isFreeShippingApplicable}
            type={type}
            deviceType={deviceType}
          />
        )}
      </div>

      <style jsx>{themedStoresListStyles}</style>
    </div>
  );
};

DeliveryOptionsContent.propTypes = {
  type: PropTypes.string,
  data: PropTypes.array,
  setBusy: PropTypes.func,
  zoneConfig: PropTypes.object,
  setIsCambiar: PropTypes.func,
  setSelectedDeliveryOption: PropTypes.func,
  isFreeShippingApplicable: PropTypes.bool,
  deviceType: PropTypes.string,
  theme: PropTypes.object.isRequired,
  isDefaultComuna: PropTypes.bool.isRequired,
};

DeliveryOptionsContent.defaultProps = {
  type: '',
  data: [],
  setBusy: noop,
  zoneConfig: {},
  setIsCambiar: noop,
  setSelectedDeliveryOption: noop,
  isFreeShippingApplicable: false,
  deviceType: '',
};
export default withTheme(DeliveryOptionsContent);
